/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiAvv, ApiService } from '@Model';
import type { HttpActions, ListInfo, ListRequest, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of ServiceAvvController.
 */
export class ServiceAvvRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls POST /services/{rootObjectId}/avv:query
     */
    public getLinkedObjects(listRequest: ListRequest, rootObjectId: string): Promise<Result<ListInfo<ApiAvv>>> {
        return this.http.post<Result<ListInfo<ApiAvv>>, ListRequest>(`/services/${rootObjectId}/avv:query`, listRequest);
    }

    /**
     * Calls POST /services/{rootObjectId}/avv:prefill
     */
    public createPrefilled(rootObjectId: string): Promise<Result<ApiAvv>> {
        return this.http.post<Result<ApiAvv>, undefined>(`/services/${rootObjectId}/avv:prefill`, undefined);
    }

    /**
     * Calls POST /services/{rootObjectId}/avv/linkable:query
     */
    public getLinkableObjects(listRequest: ListRequest, showAll: boolean, rootObjectId: string): Promise<Result<ListInfo<ApiAvv>>> {
        const query = new URLSearchParams();
        query.set('showAll', `${showAll}`);

        return this.http.post<Result<ListInfo<ApiAvv>>, ListRequest>(`/services/${rootObjectId}/avv/linkable:query`, listRequest, query);
    }

    /**
     * Calls POST /services/{rootObjectId}/avv
     */
    public addLinkedObject(id: string, rootObjectId: string): Promise<Result<ApiService>> {
        const query = new URLSearchParams();
        query.set('id', `${id}`);

        return this.http.post<Result<ApiService>, undefined>(`/services/${rootObjectId}/avv`, undefined, query);
    }

    /**
     * Calls DELETE /services/{rootObjectId}/avv/{unlinkId}
     */
    public deleteLinkedObject(unlinkId: string, rootObjectId: string): Promise<Result<ApiService>> {
        return this.http.delete<Result<ApiService>>(`/services/${rootObjectId}/avv/${unlinkId}`);
    }
}
